
  <template>
       <div id="map" class="regularMap"></div>
        <!--  :class="[isRent ? 'rentMap' : !isRent, 'regularMap']">  -->

     

  </template>

  <script>
    export default {
      name: 'MapDiv',
  
      data: () => ({
        isRent: false,
       
      }),
      mounted(){
        var appVue = this;
        // check if url end with '/rent/pricing'
        if (window.location.href.indexOf("/rent/pricing") > -1 || window.location.href.indexOf("/buy/info") > -1) {
          appVue.isRent = true;
        }
      }
  
  
    }
  </script>


<style>

.regularMap {
           
            height: 100%;
            /* border: 1px solid  */
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .16);
            position: relative;
}



.rentMap {
  height:586px; 
            border: solid hwb(240 68% 30%); 
            /*border-radius: 15px; */
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .16);
            position: relative;
}


</style>
  